/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Faq_License_AnswerInputs */

const en_landing_faq_license_answer = /** @type {(inputs: Landing_Faq_License_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. ShipAny Next is built for shipping production SaaS products. You own the code after cloning — no per-seat fees, no runtime dependencies on our infrastructure.`)
};

const zh_landing_faq_license_answer = /** @type {(inputs: Landing_Faq_License_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。ShipAny Next 就是为生产级 SaaS 打造的。克隆之后代码归你——没有按用户数收费，也不依赖我们的任何基础设施。`)
};

/**
* | output |
* | --- |
* | "Yes. ShipAny Next is built for shipping production SaaS products. You own the code after cloning — no per-seat fees, no runtime dependencies on our infrastru..." |
*
* @param {Landing_Faq_License_AnswerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_faq_license_answer = /** @type {((inputs?: Landing_Faq_License_AnswerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Faq_License_AnswerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_faq_license_answer(inputs)
	return zh_landing_faq_license_answer(inputs)
});
export { landing_faq_license_answer as "landing.faq.license.answer" }